import { IconPropsType } from '..';

export const CopyIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.72953 4C2.4901 4 1.47696 5.00286 1.46667 6.24229V12.9371C1.46667 13.7586 1.90496 14.4784 2.56142 14.875C2.88865 15.0731 3.2699 15.1906 3.67763 15.1995L3.70382 15.2H3.70896H10.4038C11.639 15.2 12.6463 14.2071 12.6664 12.9805L12.6667 12.9629V6.26286C12.6667 5.01829 11.6587 4.00515 10.4192 4H3.72953Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.92953 0.800003C5.6901 0.800003 4.67696 1.80286 4.66667 3.04229V9.73715C4.66667 10.5586 5.10496 11.2784 5.76142 11.675C6.08865 11.8731 6.4699 11.9906 6.87763 11.9995L6.90382 12H6.90896H13.6038C14.839 12 15.8463 11.0071 15.8664 9.78047L15.8667 9.76286V3.06286C15.8667 1.81829 14.8587 0.805146 13.6192 0.800003H6.92953ZM14.2667 9.6C14.2667 10 13.8667 10.4 13.4667 10.4H7.06667C6.66667 10.4 6.26667 10 6.26667 9.6V3.2C6.26667 2.8 6.66667 2.4 7.06667 2.4H13.4667C13.8667 2.4 14.2667 2.8 14.2667 3.2V9.6Z"
    />
  </svg>
);
